import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg1Persoon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M25 13h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0m0 0h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0M17.5 32h-1v-9h1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg1Persoon);

export default ForwardRef;
